const TERMINAL_STATUSES = new Set([
    'COMPLETED',
    'COMPLETED_WITH_ERRORS',
    'FAILED',
    'CANCELLED',
]);

export const createProductSynchronizationPoller = ({
    fetchJob,
    onUpdate,
    onTerminal,
    onTemporaryError,
    intervalMs = 2500,
}) => {
    let intervalId = null;
    let inFlight = false;
    let stopped = true;
    let currentJobId = null;

    const stop = () => {
        stopped = true;
        if (intervalId) {
            window.clearInterval(intervalId);
            intervalId = null;
        }
    };

    const poll = async () => {
        if (stopped || inFlight || !currentJobId) {
            return;
        }
        inFlight = true;
        try {
            const job = await fetchJob(currentJobId);
            if (stopped) {
                return;
            }
            onUpdate(job);
            if (TERMINAL_STATUSES.has(job.status)) {
                stop();
                onTerminal(job);
            }
        } catch (error) {
            if (!stopped && onTemporaryError) {
                onTemporaryError(error);
            }
        } finally {
            inFlight = false;
        }
    };

    const start = (jobId) => {
        stop();
        currentJobId = jobId;
        stopped = false;
        const initialPoll = poll();
        intervalId = window.setInterval(poll, intervalMs);
        return initialPoll;
    };

    return { start, stop, pollNow: poll };
};
